import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IhmAutocompleteLargeChipsListComponent } from './ihm-autocomplete-large-chips-list.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IhmPipesModule } from '../../shared/pipes/ihm-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    IhmPipesModule
  ],
  declarations: [IhmAutocompleteLargeChipsListComponent],
  exports: [IhmAutocompleteLargeChipsListComponent]
})
export class IhmAutocompleteLargeChipsListModule {}
